"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_OVERLAY_PROPS = exports.OPEN = exports.CLOSE = void 0;
var OPEN = '@@redux-form-overlay/OPEN';
exports.OPEN = OPEN;
var CLOSE = '@@redux-form-overlay/CLOSE';
exports.CLOSE = CLOSE;
var SET_OVERLAY_PROPS = '@@redux-form-overlay/SET_OVERLAY_PROPS';
exports.SET_OVERLAY_PROPS = SET_OVERLAY_PROPS;